var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent, Children } from 'react';
import { defaultProps } from './defaults';
import { BreadcrumbItem } from './BreadcrumbItem';
import { BreadcrumbSeparator } from './BreadcrumbSeparator';
import { DivTag } from '../../Utils/AtomicTag';
var Breadcrumb = /** @class */ (function (_super) {
    __extends(Breadcrumb, _super);
    function Breadcrumb() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Breadcrumb.prototype.renderCrumbs = function () {
        var _a = this.props, children = _a.children, separator = _a.separator;
        var crumbs = Children.map(children, function (element, index) {
            if (!element || !React.isValidElement)
                return element;
            return React.cloneElement(element, __assign({ separator: separator, key: index }, element.props));
        });
        return crumbs;
    };
    Breadcrumb.prototype.render = function () {
        return (React.createElement(DivTag, __assign({ name: Breadcrumb.NAME, atomics: [] }, this.props), this.renderCrumbs()));
    };
    Breadcrumb.defaultProps = defaultProps;
    Breadcrumb.NAME = 'breadcrumb';
    Breadcrumb.displayName = 'Breadcrumb';
    Breadcrumb.Item = BreadcrumbItem;
    Breadcrumb.Separator = BreadcrumbSeparator;
    return Breadcrumb;
}(PureComponent));
export { Breadcrumb };
